'use client'

import { ButtonSelect } from '../button-select'

const numericOptions = [
  { id: '2', label: '2 คน', min: 2, max: 2 },
  { id: '3-5', label: '3 - 5 คน', min: 3, max: 5 },
  { id: '5-10', label: '5 - 10 คน', min: 5, max: 10 },
]

export function TeamNumberSelect({
  onSelect,
  className,
}: {
  onSelect: (teamNumberMin: number | null, teamNumberMax: number | null) => void
  className?: string
}) {
  return (
    <div className={className}>
      {numericOptions.map((option) => (
        <ButtonSelect
          key={option.id}
          size="sm"
          handleSelect={(isActive) => {
            if (isActive) {
              onSelect(option.min, option.max)
            } else {
              onSelect(null, null)
            }
          }}
        >
          {option.label}
        </ButtonSelect>
      ))}
      <ButtonSelect
        handleSelect={(isActive) => {
          if (isActive) {
            onSelect(null, null)
          } else {
            onSelect(0, null)
          }
        }}
        size="sm"
      >
        ไม่จำกัดจำนวน
      </ButtonSelect>
    </div>
  )
}
